import Vue from 'vue'
import axios from 'axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full.esm'
import VueWait from 'vue-wait'
import VueAxios from 'vue-axios'
import auth from '@websanova/vue-auth/src/v2.js'
import driverHttpAxios from '@websanova/vue-auth/src/drivers/http/axios.1.x.js'
import driverRouterVueRouter from '@websanova/vue-auth/src/drivers/router/vue-router.2.x.js'
import router from '@/router'
import App from '@/App.vue'
import VuexORM from '@vuex-orm/core'
import Vuex from 'vuex'
import VueApexCharts from 'vue-apexcharts'
import { User, Transaction, Referral, News, Device, Client } from '@/models'
import {formatCents, formatDollars} from '@/helpers'

Vue.config.productionTip = false

let http = ''
let host = ''
if (process.env.NODE_ENV !== 'production') {
  http = 'http'
  host = '127.0.0.1:8100'
} else {
  http = 'https'
  host = 'coinsurf.com'
}

Vue.httpProtocol = http
Vue.host = host
axios.defaults.baseURL = `${http}://${host}`
Vue.use(VueAxios, axios)

Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
Vue.use(Vuex)

const database = new VuexORM.Database()
database.register(User)
database.register(Transaction)
database.register(Referral)
database.register(News)
database.register(Device)
database.register(Client)

const store = new Vuex.Store({
  plugins: [VuexORM.install(database)]
})

Vue.router = router

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.use(auth, {
  plugins: {
    http: Vue.axios,
    router: Vue.router,
  },
  drivers: {
    auth: {
      request(req, token) {
        // if (req.url === '/api/v1/refresh-token') {
        //     console.log(req)
        // }
        this.drivers.http.setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
      },

      response(res) {
        if (Object.prototype.hasOwnProperty.call(res, 'data')) {
          if (Object.prototype.hasOwnProperty.call(res.data, 'access')) {
            return res.data.access
          }

        }
      }
    },
    http: driverHttpAxios,
    router: driverRouterVueRouter,
  },
  options: {
    rolesKey: 'type',
    notFoundRedirect: {name: 'login'},
    loginData: {url: '/api/v1/login', method: 'POST', redirect: null, fetchUser: true, staySignedIn: true},
    refreshData: {url: '/api/v1/refresh-token', method: 'POST', enabled: false},
    registerData: {url: '/api/v1/register', method: 'POST', redirect: null, fetchUser: true, staySignedIn: true},
    logoutData: {redirect: '/login', makeRequest: false},
    fetchData: {url: '/api/v1/profile', method: 'GET', enabled: true},
    parseUserData: (data) => {
      return data
    }
  }
})


const decimals = 2

Vue.filter("formatByte", function (bytes) {
  if (!bytes || bytes <= 0) return '0 B';

  const k = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
})

Vue.filter("shortUuid", function (value) {
  return value.substring(0, 8)
})

Vue.filter("formatDate", function (d) {
  d = new Date(d)
  let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
  let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d)
  let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)

  return `${mo} ${da}. ${ye}`
})

Vue.filter("formatCents", function (value) {
  return formatCents(value)
})

Vue.filter("formatDollars", function (value) {
  return formatDollars(value)
})

Vue.use(VueWait)

new Vue({
  store,
  router,
  render: h => h(App),
  wait: new VueWait({
    // Defaults values are following:
    useVuex: false,              // Uses Vuex to manage wait state
    vuexModuleName: 'wait',      // Vuex module name

    registerComponent: true,     // Registers `v-wait` component
    componentName: 'v-wait',     // <v-wait> component name, you can set `my-loader` etc.

    registerDirective: true,     // Registers `v-wait` directive
    directiveName: 'wait',       // <span v-wait /> directive name, you can set `my-loader` etc.
  }),
}).$mount('#app')
